import React, { Component } from 'react'
import {Button} from '@material-ui/core'
export default class download_insight extends Component {
   
    render() {
        const {toggleDownload}=this.props
        return (
            <div className='download-section'>
                {/* <div className='download-wrapper' >
                    <div className='pdf-square'>
                        <h1>PDF</h1>
                    </div>
                    <div className='download-caption2'>
                        <div>
                        <p>STOCKDALE PARADOX :Strategic Turnaround dalam 3 Bulan</p>
                        </div>
                        <div className='download-footer'>
                            <p>Author :<br/>Suwardi Luis & Djunaidi Baharuddin</p>
                            <Button onClick={()=>toggleDownload('stockdale_paradox.pdf')} color='primary' variant='contained' size='small' className='download-btn'>
                                Download
                            </Button>
                        </div>
                    </div>
                   
                </div> */}
                {/* <div className='download-wrapper' >
                    <div className='pdf-square'>
                        <h1>PDF</h1>
                    </div>
                    <div className='download-caption'>
                        <div>
                        <p>How can business and HR leaders manage challenges and find opportunities in the new realities of working at home?</p>
                        </div>
                        <div className='download-footer'>
                            <p>Author :<br/>Prof. Dave Ulrich</p>
                            <Button onClick={()=>toggleDownload('whf_DU_jz.pdf')} color='primary' variant='contained' size='small' className='download-btn'>
                                Download
                            </Button>
                        </div>
                    </div>
                   
                </div> */}
                {/* <div className='download-wrapper' >
                    <div className='pdf-square'>
                        <h1>PDF</h1>
                    </div>
                    <div className='download-caption2'>
                        <div>
                        <p>What’s Next in the Coronavirus Crisis? Phases of a Crisis and HR Responses</p>
                        </div>
                        <div className='download-footer'>
                            <p>Author :<br/>Prof. Dave Ulrich</p>
                            <Button onClick={()=>toggleDownload('what_next_DU.pdf')} color='primary' variant='contained' size='small' className='download-btn'>
                                Download
                            </Button>
                        </div>
                    </div>
                   
                </div> */}
                
                
                
            </div>
        )
    }
}
